import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { createLogger } from "redux-logger";
import ReduxThunk from "redux-thunk";
import { reducer as formReducer } from "redux-form";
import heartbeats from "heartbeats";
import userReducer from "./reducers/userReducer";
import configReducer from "./reducers/configReducer";
import serviceReducer from "./reducers/serviceReducer";
import contactReducer from "./reducers/contactReducer";
import historyReducer from "./reducers/historyReducer";
import settingReducer from "./reducers/settingReducer";
import { messageReducer } from "./reducers/messageReducer";
import connectionReducer from "./reducers/connectionReducer";
import sipReducer from "./reducers/sipReducer";
import resetPasswordReducer from "./reducers/resetPasswordReducer";
import registrationReducer from "./reducers/registrationReducer";
import changeUserReducer from "./reducers/changeUserReducer";
import debugReducer from "./reducers/debugReducer";
import accessibilityReducer from "./reducers/accessibilityReducer";
import callReducer from "./reducers/callReducer";
import { networkReducer } from "./reducers/networkReducer";
import { heartbeat } from "./actions/heartbeatActions";
import kioskReducer from "./kiosk/kioskReducer";
import { createHashHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { combineConsumers } from "./modules/redux-consumer";
import kioskStateConsumer from "./consumers/kioskStateConsumer";
import localStreamConsumer from "./consumers/localStreamConsumer";
import { kioskCallStateConsumer } from "./consumers/kioskStateConsumer";

const rootReducer = combineReducers({
  user: userReducer,
  config: configReducer,
  service: serviceReducer,
  contact: contactReducer,
  history: historyReducer,
  setting: settingReducer,
  form: formReducer,
  message: messageReducer,
  connection: connectionReducer,
  sip: sipReducer,
  resetPassword: resetPasswordReducer,
  registration: registrationReducer,
  changeUser: changeUserReducer,
  accessibility: accessibilityReducer,
  debug: debugReducer,
  call: callReducer,
  network: networkReducer,
  kiosk: kioskReducer,
});

export const history = createHashHistory();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  connectRouter(history)(rootReducer),
  {},
  composeEnhancers(
    applyMiddleware(
      ReduxThunk,
      routerMiddleware(history),
      createLogger({
        predicate: (getState, action) => {
          if (getState().config.mode.debug_enabled !== true) return false;
          if (("" + action.type).indexOf("@@redux-form") !== -1) return false;
          return true;
        },
        collapsed: (getState, action) => true,
      })
    )
  )
);

combineConsumers(store, {
  kioskStateConsumer,
  localStreamConsumer,
  kioskCallStateConsumer,
});

//Heartbeats
var heart = heartbeats.createHeart(1000);

heart.createEvent(1, function(count, last) {
  store.dispatch(heartbeat(1));
});

//5sec
heart.createEvent(5, function(count, last) {
  store.dispatch(heartbeat(5));
});

//20sec
heart.createEvent(20, function(count, last) {
  store.dispatch(heartbeat(20));
});

//60sec
heart.createEvent(60, function(count, last) {
  store.dispatch(heartbeat(60));
});

export default store;






// WEBPACK FOOTER //
// ./src/store.js